<div class="offer__card" (click)="showOffer()">
    <div class="offer__card__image-container">
        <img draggable="false" [src]="offer()?.image?.[translate.currentLang]" (error)="tools.onImgOfferError($event)">
    </div>
    <div class="offer__card__text-container">
        <p>{{offer()?.description?.[translate.currentLang]}}</p>
        <span>
            {{'Del' | translate}} {{offer()?.start| date: 'dd/MM/yy'}} 
            {{'al' | translate}} {{offer()?.end | date: 'dd/MM/yy'}}
        </span>
    </div>
</div>